<template>
  <div>
    <div>
      <table class="odds-details">
        <thead>
          <tr>
            <th
              class="border-solid border font-bold text-white align-middle leading-6 text-xs"
              rowspan="2"
            >
              {{ $t('time') }}
            </th>
            <th
              class="border-solid border font-bold text-white align-middle leading-6 text-xs"
              colspan="2"
              rowspan="2"
            >
              {{ $t('event') }}
            </th>
            <th
              class="border-solid border font-bold text-white align-middle leading-6 text-xs"
              colspan="6"
            >
              {{ $t(bettingTableStateKey[currentTable]) }}
            </th>
          </tr>
          <tr>
            <th
              class="border-solid border font-bold text-white align-middle leading-6 text-xs"
            >
              {{ $t('hdp') }}
            </th>
            <th
              class="border-solid border font-bold text-white align-middle leading-6 text-xs"
            >
              {{ $t('home') }}
            </th>
            <th
              class="border-solid border font-bold text-white align-middle leading-6 text-xs"
            >
              {{ $t('away') }}
            </th>
            <th
              class="border-solid border font-bold text-white align-middle leading-6 text-xs"
            >
              {{ $t('goal') }}
            </th>
            <th
              class="border-solid border font-bold text-white align-middle leading-6 text-xs"
            >
              {{ $t('over') }}
            </th>
            <th
              class="border-solid border font-bold text-white align-middle leading-6 text-xs"
            >
              {{ $t('under') }}
            </th>
          </tr>
        </thead>
        <tbody v-for="(listItem, index) in list" :key="index">
          <tr v-show="isShowLeague(listItem?.league?.en)">
            <td
              colspan="6"
              class="league-name uppercase text-white text-left font-bold"
            >
              {{ (listItem?.league as any)?.[locale] }}
            </td>
            <td
              colspan="6"
              class="league-name uppercase text-white text-left font-bold"
            />
          </tr>
          <tr
            v-for="(item, indexItem) in listItem?.record"
            v-show="
              isShowTeamByTime(item, false, bettingState.timeNow) &&
              isShowLeague(listItem?.league?.en)
            "
            :key="indexItem"
            class="odds-group"
          >
            <td>
              {{ timeFormat(item?.koTime) }}
            </td>
            <td>
              <span :class="advColorClass(ADV_SELECTION.HOME_ADV, item?.adv)">
                {{ `(1st) ${(item.home as any)?.[locale]}` }}
              </span>
            </td>
            <td>
              <span :class="advColorClass(ADV_SELECTION.AWAY_ADV, item?.adv)">
                {{ `(1st) ${(item.away as any)?.[locale]}` }}
              </span>
            </td>
            <td class="odds-line">
              <span v-html="hdpFormat(item?.fhHdp)" />
            </td>
            <td
              @click="
                onClickOdds(
                  {
                    id: item?.id,
                    matchId: item?.matchId,
                    betType: 'fh hdp',
                    oddsType: bettingOddsType.FH_HDP_HOME,
                    value: item?.fhHdpHome,
                    oldValue: item?.fhHdpHome,
                    label: item?.home,
                    odds: item?.fhHdp,
                    adv: item?.adv,
                    isHome: true,
                    oddsLine: item?.fhHdpOddsLine,
                    league: listItem?.league,
                  },
                  item
                )
              "
            >
              <span>
                <a
                  class="odds cursor-pointer block border-none w-full m-0 p-0 whitespace-nowrap text-center leading-7 font-bold"
                >
                  {{ oddsFormat(item?.fhHdpHome) }}
                </a>
              </span>
            </td>
            <td
              @click="
                onClickOdds(
                  {
                    id: item?.id,
                    matchId: item?.matchId,
                    betType: 'fh hdp',
                    oddsType: bettingOddsType.FH_HDP_AWAY,
                    value: item?.fhHdpAway,
                    oldValue: item?.fhHdpAway,
                    label: item?.away,
                    odds: item?.fhHdp,
                    adv: item?.adv,
                    isHome: false,
                    oddsLine: item?.fhHdpOddsLine,
                    league: listItem?.league,
                  },
                  item
                )
              "
            >
              <span>
                <a
                  class="odds cursor-pointer block border-none w-full m-0 p-0 whitespace-nowrap text-center leading-7 font-bold"
                >
                  {{ oddsFormat(item?.fhHdpAway) }}
                </a>
              </span>
            </td>
            <td class="odds-line">
              <span v-html="hdpFormat(item?.fhOu)" />
            </td>
            <td
              @click="
                onClickOdds(
                  {
                    id: item?.id,
                    matchId: item?.matchId,
                    betType: 'ou',
                    oddsType: bettingOddsType.FH_OU_OVER,
                    value: item?.fhOuOver,
                    oldValue: item?.fhOuOver,
                    label: `${$t('over')}`,
                    odds: item?.fhOu,
                    adv: item?.adv,
                    oddsLine: item?.fhOuOddsLine,
                    league: listItem?.league,
                  },
                  item
                )
              "
            >
              <span>
                <a
                  class="odds cursor-pointer block border-none w-full m-0 p-0 whitespace-nowrap text-center leading-7 font-bold"
                >
                  {{ oddsFormat(item?.fhOuOver) }}
                </a>
              </span>
            </td>
            <td
              @click="
                onClickOdds(
                  {
                    id: item?.id,
                    matchId: item?.matchId,
                    betType: 'ou',
                    oddsType: bettingOddsType.FH_OU_UNDER,
                    value: item?.fhOuUnder,
                    oldValue: item?.fhOuUnder,
                    label: `${$t('under')}`,
                    odds: item?.fhOu,
                    adv: item?.adv,
                    oddsLine: item?.fhOuOddsLine,
                    league: listItem?.league,
                  },
                  item
                )
              "
            >
              <span>
                <a
                  class="odds cursor-pointer block border-none w-full m-0 p-0 whitespace-nowrap text-center leading-7 font-bold"
                >
                  {{ oddsFormat(item?.fhOuUnder) }}
                </a>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from 'vue';
import { BettingTableStateKey } from '../../constants/BettingTableState.enum';
import { useOddsFormat } from '@/composition/odds-format';
import { useI18n } from 'vue-i18n';
import { useUnixTimeToDate } from '@/composition/datetime-format';
import { useAdvTextColor } from '@/composition/adv-color';
import { ADV_SELECTION } from '@/constants/Ticket.enum';
import { useHdpFormat } from '@/composition/hdp-format';
import { useBettingStore } from '../../store/betting';
import { BettingOddsType, FhOddsType } from '@/constants/OddsType.enum';
import { useLeagueDisplay } from '../../composition/league-display';

import type { FhHdp } from '@/interfaces/FhHdp.interface';
import type { FhHdpMatch } from '@/interfaces/FhHdpMatch.interface';
import type { TeamSelected } from '../../interfaces/TeamSelected.interface';
import { useMemberStore } from '../../store/member';

export default defineComponent({
  name: 'BettingTable',
  props: {
    list: {
      type: Array as PropType<FhHdp[]>,
      required: true,
    },
  },
  emits: ['click:match', 'click:odds'],
  setup(_, { emit }) {
    const { locale } = useI18n();
    const bettingStore = useBettingStore();
    const memberStore = useMemberStore();
    const bettingOddsType = computed(() => BettingOddsType);
    const { isShowLeague, isShowTeamByTime } = useLeagueDisplay();

    const currentTable = computed(
      () => bettingStore.$state.currentBettingTable
    );
    const member = computed(() => memberStore.member);

    const bettingState = computed(() => bettingStore.$state);
    const bettingTableStateKey = computed(() => BettingTableStateKey);

    const hdpFormat = (hdp: string | number) => useHdpFormat(hdp);

    const timeFormat = (accDate: string) => {
      return useUnixTimeToDate(accDate, 'HH:mm');
    };

    const oddsFormat = (oddsValue: number) => {
      return useOddsFormat(oddsValue);
    };

    const advColorClass = (currentAdv: number, advValue: number) => {
      return useAdvTextColor(currentAdv, advValue);
    };

    const validateUserPermission = (teamSelected: TeamSelected) => {
      return (
        member.value?.isFh &&
        FhOddsType.some((el) => el === teamSelected.oddsType)
      );
    };

    const onClickOdds = (teamSelected: TeamSelected, matchItem: FhHdpMatch) => {
      if (validateUserPermission(teamSelected)) {
        if (teamSelected.value >= 0) {
          emit('click:odds', teamSelected);
          emit('click:match', matchItem);
        }
      } else {
        bettingStore.bettingErrorMessage =
          'ยูซเซอร์ไม่สามารถแทงประเภทครึ่งแรกได้';
        bettingStore.isShowBettingModal = true;
      }
    };

    return {
      bettingOddsType,
      currentTable,
      bettingTableStateKey,
      onClickOdds,
      locale,
      timeFormat,
      oddsFormat,
      advColorClass,
      ADV_SELECTION,
      hdpFormat,
      isShowLeague,
      isShowTeamByTime,
      bettingState,
    };
  },
});
</script>
